<template>
  <tr 
    :class="baseTableRowClasses" 
    class="base-table-row"
  >
    <slot />
  </tr>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  type: {
    type: String,
    default: "body",
  },
});

const baseTableRowClasses = computed(() => ({
  [`base-table-row--type-${props.type}`]: true,
}));
</script>

<style lang="scss">
@import "./base-table-row.scss";
</style>
